const FinancialQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'order.orderName', // 订单名称
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderName',
        },
        {
            // name:'order.customerType', // 发票号
            key:'invoice_no',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.invoiceNo',
        },
        {
            // name:'order.orderStatus', // 订单状态
            key:'order_status',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderStatus',
            optionToLocale:true,
            options:[
                {
                    value:7,
                    label:'order.obligation'
                },
                {
                    value:0,
                    label:'order.partialPay'
                },
                {
                    value:1,
                    label:'order.pay'
                },
            ]
        },
        {
            // name:'order.orderStatus', // 发货状态
            key:'courier_status',
            type:'select',   
            // allowClear:true,
            width:'200px',
            placeholder:'order.courierStatus',
            optionToLocale:true,
            options:[
                {
                    value:2,
                    label:'order.partialShip'
                },
                {
                    value:3,
                    label:'order.shiped'
                },
                {
                    value:4,
                    label:'order.signedFor'
                },
            ]
        },
        {
            // name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderSource',
            // optionToLocale:true,
            options:[]
        },
        {
            // name:'order.orderDate', // 订单时间
            key:'order_date',
            type:'dateRange',   
            allowClear:true,
            width:'300px',
            placeholder1:'financial.orderStartDate',
            placeholder2:'financial.orderEndDate',
        },
        {
            // name:'order.invoiceTimestamp', // 发票时间
            key:'invoice_timestamp',
            type:'dateRange',   
            allowClear:true,
            width:'300px',
            placeholder1:'financial.invoiceStartDate',
            placeholder2:'financial.invoiceEndDate',
        },
        {
            // name:'order.financeCheckTime', // 执行时间
            key:'finance_check_time',
            type:'dateRange',   
            allowClear:true,
            width:'300px',
            placeholder1:'financial.updateStartDate',
            placeholder2:'financial.updateEndDate',
        },
    ]
}

const EditForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'customer.customerName', // 客户名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.customerName2', // 客户名称2
            key:'name2',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.customerEmail', // 邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'400px',
            placeholder:'base.input',
        },
        // {
        //     name:'customer.sex', // 性别
        //     key:'sex',
        //     type:'select',   
        //     allowClear:true,
        //     width:'400px',
        //     placeholder:'base.select',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             label:'customer.male',
        //             value:1,
        //         },
        //         {
        //             label:'customer.female',
        //             value:2,
        //         },
        //         {
        //             label:'customer.unknown',
        //             value:0,
        //         },
        //     ]
        // },
        {
            name:'customer.customerPhone', // 客户电话
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.customerState', // 客户所在州
            key:'state',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCity', // 客户所在城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.addressType', // 地址类型
            key:'address_type', 
            type:'select',
            required:true,
            width:'400px',
            placeholder:'base.input',
            optionToLocale:true,
            options:[
                {
                    label:'customer.defaultAddress',
                    value:0,
                },
                {
                    label:'customer.invoiceAddress',
                    value:1
                }
            ]
        },
        {
            name:'customer.customerAddr', // 客户地址
            key:'address',
            type:'input',   
            allowClear:true,
            required:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.customerAddr2', // 客户地址2
            key:'address2',
            type:'input',   
            allowClear:true,
            required:false,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'customer.billingAddress', // 发票地址
            key:'billing_address',
            type:'input',   
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
        },
    ]
}

const AddCustomerForm = {
    labelColProps: { span: 6 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'customer.customerName', // 客户名称
            key:'name',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerName2', // 客户名称2
            key:'name2',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        // {
        //     name:'customer.sex', // 性别
        //     key:'sex',
        //     type:'select',   
        //     allowClear:true,
        //     width:'80%',
        //     placeholder:'base.select',
        //     optionToLocale:true,
        //     options:[
        //         {
        //             label:'customer.male',
        //             value:1,
        //         },
        //         {
        //             label:'customer.female',
        //             value:2,
        //         },
        //         {
        //             label:'customer.unknown',
        //             value:0,
        //         },
        //     ]
        // },
        {
            name:'customer.customerEmail', // 客户邮箱
            key:'email',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'customer.customerType', // 客户类型
            key:'type',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
            ]
        },
        {
            name:'customer.customerPhone', // 客户电话
            key:'phone',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.zip', // 邮编
            key:'zip',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCountry', // 客户所在国家
            key:'country',
            type:'select',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.select',
        },
        {
            name:'customer.customerState', // 客户所在州
            key:'state',
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerCity', // 客户所在城市
            key:'city',
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.addressType', // 地址类型
            key:'address_type', 
            type:'select',
            required:true,
            width:'80%',
            placeholder:'base.input',
            optionToLocale:true,
            options:[
                {
                    label:'customer.defaultAddress',
                    value:0,
                },
                {
                    label:'customer.invoiceAddress',
                    value:1
                }
            ]
        },
        {
            name:'customer.customerAddr', // 客户地址
            key:'address', 
            type:'input',   
            allowClear:true,
            required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.customerAddr2', // 客户地址2
            key:'address2', 
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
        {
            name:'customer.billingAddress', // 账单地址
            key:'billing_address', 
            type:'input',   
            allowClear:true,
            // required:true,
            width:'80%',
            placeholder:'base.input',
        },
    ]
}

// 现金流列表查询
const CashFlowQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'financial.recordTimestamp', // 记录现金流时间
            key:'record_date',
            type:'date',   
            allowClear:true,
            showTime:false,
            width:'300px',
            placeholder:'financial.recordTimestamp',
        },
    ]
}

// 新增现金流
const AddCashFlowForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'financial.recordTimestamp', // 记录现金流时间
            key:'record_timestamp',
            type:'date',   
            allowClear:true,
            required:true,
            showTime:false,
            disabledDate:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'financial.amountIn', // 流入
            key:'amount_in',
            type:'inputNumber',   
            required:true,
            width:'400px',
            max:999999999,
            placeholder:'base.input',
            hideButton:true,
        },
        {
            name:'financial.amountOut', // 流出
            key:'amount_out',
            type:'inputNumber',   
            required:true,
            width:'400px',
            max:999999999,
            placeholder:'base.input',
            hideButton:true,
        },

        {
            name:'financial.amountTotal', // 现金流合计
            key:'amount_total',
            type:'inputNumber', 
            required:true,
            disabled:true,
            width:'400px',
            placeholder:'base.input',
            hideButton:true,
        },
    ]
}

// 应付列表查询
const AccountQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'financial.recordTimestamp', // 记录现金流时间
            key:'record_date',
            type:'date',   
            allowClear:true,
            showTime:false,
            width:'300px',
            placeholder:'financial.recordTimestamp',
        },
    ]
}

// 新增应付
const AddAccountForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'financial.recordTimestamp', // 记录现金流时间
            key:'record_timestamp',
            type:'date',   
            allowClear:true,
            required:true,
            showTime:false,
            disabledDate:true,
            width:'400px',
            placeholder:'base.input',
        },
        {
            name:'financial.account', // 应付
            key:'amount_out',
            type:'inputNumber',   
            required:true,
            width:'400px',
            max:999999999,
            placeholder:'base.input',
            hideButton:true,
        },
    ]
}

// ERP价目表列表查询
const PriceListQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'order.source', // 渠道来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderSource',
            options:[]
        },
        {
            // name:'order.sku', // sku
            key:'sku',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.sku',
            options:[]
        },
        {
            // name:'order.orderChannelType', // 订单类型
            key:'type',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderChannelType',
            optionToLocale:true,
            options:[
                {
                    label:'order.user',
                    value:0,
                },
                {
                    label:'order.dealer',
                    value:1,
                }
            ]
        },
        {
            // name:'order.inventoryCode', // 物料编码
            key:'inventory_code',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.inventoryCode',
        },
        {
            // name:'financial.priceListName', // 价目表名称
            key:'price_list_name',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'financial.priceListName',
            optionToLocale:true,
            options:[
                {
                    label:'HEPHA DEALER-BRONZE',
                    value:'HEPHA DEALER-BRONZE',
                },
                {
                    label:'HEPHA DEALER-GOLD',
                    value:'HEPHA DEALER-GOLD',
                },
                {
                    label:'HEPHA DEALER-SILVER',
                    value:'HEPHA DEALER-SILVER',
                },
                {
                    label:'HEPHA DEALER-PlATIN',
                    value:'HEPHA DEALER-PlATIN',
                },
                {
                    label:'HEPHA',
                    value:'HEPHA',
                },
                {
                    label:'HEPHA B2C RRP',
                    value:'HEPHA B2C RRP',
                },
                {
                    label:'HEPHA official website',
                    value:'HEPHA official website',
                },
                {
                    label:'HEPHA GMBH',
                    value:'HEPHA GMBH',
                },
            ],
        },
        {
            // name:'order.customerCumber', // 客户编码
            key:'customer_number',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.customerNumber',
        },
    ]
}

// 新增税率
const AddTaxForm = {
    // layout:'inline',
    labelColProps: { span: 5 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            name:'order.country', // 国家编码
            key:'country',
            type:'select',   
            required:true,
            allowClear:true,
            width:'400px',
            placeholder:'base.input',
            options:[]
        },
        {
            name:'order.tax', // 税率
            key:'tax',
            type:'inputNumber',   
            required:true,
            suffix:true,
            suffixText:'%',
            width:'400px',
            placeholder:'base.input',
            hideButton:true,
        },
    ]
}

// 新增等级
const AddLevelForm = {
    // layout:'inline',
    labelColProps: { span: 5 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            name:'financial.level', // 等级
            key:'level',
            type:'input',   
            required:true,
            suffix:true,
            suffixText:'%',
            width:'400px',
            placeholder:'base.input',
            hideButton:true,
        },
    ]
}

// 发货签收
const SignatureListQueryForm = {
    layout:'inline',
    labelColProps: { span: 5 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'180px',
    showSlot:false,
    formData:{},
    formField:[
        {
            // name:'order.orderName', // 发货签收/退货签收
            key:'sign_type',
            type:'select',
            width:'200px',
            placeholder:'financial.signType',
            optionToLocale:true,
            options:[
                {
                    label:'financial.shipSign',
                    value:1,
                },
                {
                    label:'financial.returnSign',
                    value:2,
                }
            ]
        },
        {
            // name:'order.orderName', // 订单名称
            key:'order_name',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.orderName',
            options:[]
        },
        {
            // name:'stock.deliveryNumber', // 出库单号
            key:'mes_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'stock.deliveryNumber',
        },
        {
            // name:'order.sku', // sku
            key:'sku',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.sku',
            options:[]
        },
        {
            // name:'stock.logisticsType', // 物流公司
            key:'logistic_type',
            type:'select', 
            width:'200px',
            allowClear:true,
            placeholder:'financial.logisticType',
            options:[]
        },
    ]
}

FinancialQuery.formField.forEach(item=>{
    FinancialQuery.formData[item.key] = ''
})

EditForm.formField.forEach(item=>{
    EditForm.formData[item.key] = ''
})

AddCustomerForm.formField.forEach(item=>{
    AddCustomerForm.formData[item.key] = ''
})

CashFlowQueryForm.formField.forEach(item=>{
    CashFlowQueryForm.formData[item.key] = ''
})

AddCashFlowForm.formField.forEach(item=>{
    AddCashFlowForm.formData[item.key] = ''
})

AccountQueryForm.formField.forEach(item=>{
    AccountQueryForm.formData[item.key] = ''
})

AddAccountForm.formField.forEach(item=>{
    AddAccountForm.formData[item.key] = ''
})

PriceListQueryForm.formField.forEach(item=>{
    PriceListQueryForm.formData[item.key] = ''
})

AddTaxForm.formField.forEach(item=>{
    AddTaxForm.formData[item.key] = ''
})

AddLevelForm.formField.forEach(item=>{
    AddLevelForm.formData[item.key] = ''
})

SignatureListQueryForm.formField.forEach(item=>{
    SignatureListQueryForm.formData[item.key] = ''
})

export {
    FinancialQuery,
    EditForm,
    AddCustomerForm,
    CashFlowQueryForm,
    AddCashFlowForm,
    AccountQueryForm,
    AddAccountForm,
    PriceListQueryForm,
    AddTaxForm,
    AddLevelForm,
    SignatureListQueryForm,
}